var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-login-cargando"},[_c('div',{staticClass:"row justify-content-center w-100"},[_c('div',{staticClass:"col-10 col-sm-8 col-md-7 col-lg-5 col-xl-5 text-center"},[_c('img',{staticClass:"img-logo heartbeat",attrs:{"src":"/img/generales/logoClaroMCD.svg","alt":""}})])])])
}]

export { render, staticRenderFns }